<div class="popup-screen">
  <div class="popup-container">
    <div class="popup-header">
      <div>
        <button *ngIf="selectedApi" class="back-button" (click)="selectApi(null)">
          <i class="fas fa-arrow-left"></i>
        </button>
        <span>{{selectedApi ? (selectedApi === 'risa' ? 'RISA Files Import' : (selectedApi | titlecase) + ' API') : 'Select API to Trigger'}}</span>
      </div>
      <button type="button" class="close" (click)="close()">&times;</button>
    </div>

    <div class="popup-body">
      <!-- API Selection View -->
      <div *ngIf="!selectedApi" class="api-selection">
        <div class="api-button" (click)="selectApi('deputy')">
          <h3>Deputy API</h3>
          <p>Trigger Deputy API with start date</p>
        </div>

        <div class="api-button" (click)="selectApi('risa')">
          <h3>RISA Files</h3>
          <p>Trigger RISA Files Import</p>
        </div>

        <div class="api-button" (click)="selectApi('rise')">
          <h3>RISE API</h3>
          <p>Trigger RISE API with state and date</p>
        </div>
      </div>

      <!-- Form Views -->
      <div *ngIf="selectedApi">
        <!-- Deputy Form -->
        <div *ngIf="selectedApi === 'deputy'">
          <div class="form-group">
            <label for="deputyStartDate">Start Date</label>
            <input
              type="date"
              id="deputyStartDate"
              class="form-control"
              [(ngModel)]="startDate">
          </div>
        </div>

        <!-- Rise Form -->
        <div *ngIf="selectedApi === 'rise'">
          <div class="form-group">
            <label for="riseState">State</label>
            <select
              id="riseState"
              class="form-select"
              [(ngModel)]="selectedState">
              <option *ngFor="let state of states" [value]="state.value">
                {{state.label}}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="riseStartDate">Start Date</label>
            <input
              type="date"
              id="riseStartDate"
              class="form-control"
              [(ngModel)]="startDate">
          </div>
        </div>

        <!-- RISA confirmation -->
        <div *ngIf="selectedApi === 'risa'" class="confirmation-message">
          <h4>Confirm RISA Files Import</h4>
          <p>Are you sure you want to trigger the RISA files import?</p>
        </div>
      </div>
    </div>

    <div class="popup-footer">
      <button
        *ngIf="selectedApi"
        class="btn btn-primary-soft"
        (click)="triggerApi()"
        [disabled]="loading">
        <img *ngIf="loading" src="./assets/img/loading_2.svg" class="loader-img" alt="" />
        <span>Trigger {{selectedApi === 'risa' ? 'RISA Files Import' : (selectedApi | titlecase) + ' API'}}</span>
      </button>
      <button class="btn btn-light" (click)="close()">Close</button>
    </div>
  </div>
</div>
